// Re-export generated hooks with user-friendly names
import { enhancedApi } from '@store/generated/data-migration';

export const patientDeduplicationApi = enhancedApi;

// User-friendly hook aliases
export const useFindDuplicatesMutation =
  enhancedApi.usePostV2ProviderDataMigrationPatientsDeduplicateMutation;

export const useMergePatientGroupMutation =
  enhancedApi.usePostV2ProviderDataMigrationPatientsDeduplicateMergeMutation;

export const useDismissDuplicatePairMutation =
  enhancedApi.usePostV2ProviderDataMigrationPatientsDeduplicateDismissMutation;

export const useFindAutoMergeCandidatesMutation =
  enhancedApi.usePostV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidatesMutation;

export const useBatchMergeMutation =
  enhancedApi.usePostV2ProviderDataMigrationPatientsDeduplicateBatchMergeMutation;

export const useBatchMergeJobStatusQuery =
  enhancedApi.useGetV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobIdQuery;
